const RaindropCopyrightDeclaration = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div
      className={`text-center text-xs text-color-dark-text-tertiary opacity-60`}
    >
      <div>Copyright © {currentYear} The Raindrop Group Limited.</div>
      <div>All rights reserved.</div>
    </div>
  );
};

export default RaindropCopyrightDeclaration;
